module.exports = __webpack_public_path__ + "img/71ae73a.png";